const common = {
  "nav.home": "홈",
  "nav.services": "서비스",
  "nav.about": "Medigreen 소개",
  "nav.contact": "문의하기",
  "nav.cta": "문의하기",

  "footer.brand.desc": "원유 및 LNG 조달 전문 자문 서비스. 전략적 통찰과 측정 가능한 성과를 제공합니다.",
  "footer.nav.title": "내비게이션",
  "footer.contact.title": "연락처",
  "footer.address": "1411 PALE SAN VITORES ROAD, STE 303,\nTAMUNING, GU",
  "footer.phone": "+1.671.482.0104",
  "footer.email": "info@medigreen.energy",
  "footer.copyright": "© 2026 Medigreen LLC. All rights reserved.",
  "footer.privacy": "개인정보 처리방침",
  "footer.terms": "이용약관",

  "common.readMore": "더 읽기",
  "common.viewAll": "전체 보기",
  "common.learnMore": "자세히 보기",
  "common.contactUs": "문의하기",
  "common.getStarted": "시작하기",
  "common.freeConsultation": "무료 상담",
  "common.scheduleConsultation": "무료 상담 예약",
  "common.workWithUs": "함께 일하기",
  "common.viewAllNews": "뉴스 전체 보기",
  "common.viewAllServices": "서비스 전체 보기",
  "common.startConversation": "대화 시작하기",
  "common.learnMoreAboutUs": "회사 소개 더 보기",
};

export default common;
